export const SUCCESS_CODE = {
  GET: 200,
  CREATE: 201,
};

export const ERROR_CODE = {
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  EXPECTATION_FAILED: 417,
  VALIDATION: 422,
  NOT_ACCEPTABLE: 406,
  BAD_REQUEST: 400,
  USER_EXISTED: 302,
  REACH_LIMIT_CREDITS: 405,
  NO_HAVE_ANY_CREDIT: 409,
  NO_HAVE_ENOUGH_CREDIT: 410,
  RUN_OUT_OF_CREDIT: 406,
};

export const ERROR_CODE_MESSAGE = {
  SUBSCRIPTION_NOT_FOUND: 'SUBSCRIPTION_NOT_FOUND',
  FEATURE_NOT_FOUND: 'FEATURE_NOT_FOUND',
  FEATURE_TYPE_NOT_FOUND: 'FEATURE_TYPE_NOT_FOUND',
  INVALID_VALUE: 'INVALID_VALUE',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  CLIENT_PLAN_FORBIDDEN: 'CLIENT_PLAN_FORBIDDEN',
  PLAN_NOT_FOUND: 'PLAN_NOT_FOUND',
  PLAN_FEATURE_NOT_FOUND: 'PLAN_FEATURE_NOT_FOUND',
  ENDPOINT_NOT_FOUND: 'ENDPOINT_NOT_FOUND',
  DUPLICATE_ENDPOINT_IN_FEATURE_TYPES: 'DUPLICATE_ENDPOINT_IN_FEATURE_TYPES',
  USAGE_NOT_FOUND: 'USAGE_NOT_FOUND',
  NOT_ENOUGH_CREDITS: 'NOT_ENOUGH_CREDITS',
} as const
